import { Info, Translate } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import Switch from "common/components/ui/Switch";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import CampaignPausedTooltip from "../CampaignPausedTooltip";

interface AutoTranslateProps {
  translate: boolean;
  isDisabled: boolean;
  setTranslate: (isTranslateEnabled: boolean) => void;
}

export default function AutoTranslate({
  translate,
  isDisabled,
  setTranslate,
}: AutoTranslateProps) {
  const { t } = useTranslation("campaigns", { keyPrefix: "campaignCreation" });

  return (
    <section className="flex items-center overflow-hidden rounded-2xl bg-black-50 lg:py-1.5 lg:pl-4 py-2.5 gap-x-2 pl-2.5 pr-1.5">
      <Translate weight="fill" className="size-5 mr-2.5" />

      <div className="flex-1 flex flex-col gap-y-1">
        <div className="flex items-center gap-x-1">
          <h3 className="text-sm-bold lg:text-md-bold">
            {t("automaticTranslationTitle")}
          </h3>
          <Tooltip>
            <TooltipTrigger className="lg:hidden">
              <Info weight="fill" className="size-4 text-black-300" />
            </TooltipTrigger>
            <TooltipContent>{t("automaticTranslationSubtitle")}</TooltipContent>
          </Tooltip>
        </div>
        <p className="hidden text-xs-medium text-black-500 lg:block">
          {t("automaticTranslationSubtitle")}
        </p>
      </div>

      <CampaignPausedTooltip isEditingDisabled={isDisabled}>
        {/* this wrapper is necessary because the tooltip removes the data attributes from the switch */}
        <div>
          <Switch
            checked={translate}
            onCheckedChange={setTranslate}
            disabled={isDisabled}
          />
        </div>
      </CampaignPausedTooltip>
    </section>
  );
}
